import React from 'react';
import { PageToolbar } from '../common';

/**
 * ShipmentsHeader - Header component for Shipments page
 * Contains: page title, create button, toolbar with status filter
 */
const ShipmentsHeader = ({
  viewMode,
  onToggleView,
  searchTerm,
  onSearchChange,
  onScan,
  statusFilter,
  onStatusFilterChange,
  dateFilter,
  onDateFilterChange,
  onCreateClick,
  onRefresh,
  isRefreshing,
  autoRefresh,
  onAutoRefreshChange
}) => {
  return (
    <div className="page-header">
      <div className="header-top">
        <h1>Shipments</h1>
        <div className="header-actions">
          <div className="refresh-controls">
            <button
              className={`refresh-btn${isRefreshing ? ' spinning' : ''}`}
              onClick={onRefresh}
              title="Refresh now"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
              </svg>
            </button>
            <label className="auto-refresh-label">
              <input
                type="checkbox"
                checked={autoRefresh}
                onChange={(e) => onAutoRefreshChange(e.target.checked)}
              />
              Auto Refresh
              {autoRefresh && <span className="auto-refresh-dot" />}
            </label>
          </div>
          <button className="create-button" onClick={onCreateClick}>
            + Create Shipment
          </button>
        </div>
      </div>

      <PageToolbar
        viewMode={viewMode}
        onViewModeChange={onToggleView}
        searchTerm={searchTerm}
        searchPlaceholder="Search by shipment # or customer..."
        onSearchChange={onSearchChange}
        showScanButton={true}
        onScan={onScan}
      >
        <select
          className="filter-select"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="pending">Pending</option>
          <option value="shipped">Shipped</option>
        </select>
        <div className="date-filter-wrapper">
          <input
            type="date"
            className="filter-date-input"
            value={dateFilter}
            onChange={(e) => onDateFilterChange(e.target.value)}
            title="Filter by date"
          />
          {dateFilter && (
            <button
              className="date-filter-clear"
              onClick={() => onDateFilterChange('')}
              title="Clear date filter"
            >
              �
            </button>
          )}
        </div>
      </PageToolbar>
    </div>
  );
};

export default ShipmentsHeader;
